import { Checkbox as BaseCheckbox } from '@base-ui/react/checkbox';
import type { ComponentProps } from 'react';

import { cn } from '../lib/cn';

/** 온보딩 프로필 검토의 전 항목 "확인"(P3 — 사람이 최종 확인한다)에 쓰인다. */
export function Checkbox({ className, ...props }: ComponentProps<typeof BaseCheckbox.Root>) {
  return (
    <BaseCheckbox.Root
      className={cn(
        'border-line-strong bg-surface flex size-5 shrink-0 items-center justify-center rounded-md border',
        'ease-flow hover:bg-highlight duration-fast transition-colors',
        'data-[checked]:border-selected data-[checked]:bg-selected',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <BaseCheckbox.Indicator
        className={cn(
          'text-selected-fg flex data-[unchecked]:hidden',
          'ease-flow duration-instant transition-[opacity,scale] starting:opacity-0 motion-safe:starting:scale-90',
        )}
      >
        <svg viewBox="0 0 12 12" className="size-3" fill="none" aria-hidden="true">
          <path
            d="M1.5 6.2 4.4 9l6-6.5"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </BaseCheckbox.Indicator>
    </BaseCheckbox.Root>
  );
}
